import styled, { css } from "styled-components"

export const MediaObjectsContainer = styled.div`
  display: grid;
  gap: 0.3rem;
  grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));
`
